export type ConsultationType = "intro" | "online" | "presence";

export interface BookingSelection {
  type: ConsultationType;
  lock: boolean;
}

export const BOOKING_SELECTION_KEY = "bookingSelection";
export const BOOKING_SELECTION_EVENT = "booking-selection";

export const storeBookingSelection = (selection: BookingSelection) => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.setItem(BOOKING_SELECTION_KEY, JSON.stringify(selection));
  window.dispatchEvent(new CustomEvent(BOOKING_SELECTION_EVENT, { detail: selection }));
};

export const consumeBookingSelection = (): BookingSelection | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const raw = window.sessionStorage.getItem(BOOKING_SELECTION_KEY);
  if (!raw) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(raw) as BookingSelection;
    window.sessionStorage.removeItem(BOOKING_SELECTION_KEY);
    return parsed;
  } catch (error) {
    window.sessionStorage.removeItem(BOOKING_SELECTION_KEY);
    return undefined;
  }
};
